module.exports = __webpack_public_path__ + "static/media/plus-icon.6d12b839.svg";